import React, { FC } from 'react';
import moment from 'moment';
import Modal from 'react-modal';
import CloseIcon from '@material-ui/icons/Close';
import GoogleLogin from 'react-google-login';

import { Typography } from '../../shared/typography';
import salesforce from '../../assets/images/salesforce-text.png';
import google from '../../assets/images/google.png';
import Header from './components/header';
import useHook from './hook';
import Styled from './style';
import Comments from './components/comments';
import colors from '../../assets/colors';
import AppButton from '../../shared/app-button';

type IProps = {};

const SnapSharedPage: FC<IProps> = () => {
	const {
		state,
		currentChart,
		sharedSnap,
		user,
		sendMessage,
		toggleModal,
		salesforceLogin,
		handleLogin,
		handleChange,
	} = useHook();
	const { modalIsOpen, isGoogleLoading, isSalesLoading, comment } = state;
	const { Component, defaultFields, adapter, ...rest } = currentChart || {};
	const { type, data } = sharedSnap;
	const { snap, comments } = data;
	const { capturedInput, updatedAt } = snap;
	const date = moment(updatedAt).format('DD.MM.YY');
	const SALESFORCE_ICON = 'https://getrevvy.s3.us-east-2.amazonaws.com/logos/salesforce.png';
	const OUTREACH_ICON = 'https://getrevvy.s3.us-east-2.amazonaws.com/logos/outreach.png';

	return (
		<div style={{ position: 'relative' }}>
			<Header user={user} toggleModal={toggleModal} />
			<Styled.Wrapper>
				<Styled.Content>
					<Styled.Box>
						<Styled.Header>
							<Styled.Title>
								<Typography
									text={capturedInput}
									size="king"
									color="black"
									type="king"
								/>
							</Styled.Title>
							<Styled.Descr>
								{(!data?.source || data?.source === 'salesforce')
									? <img src={SALESFORCE_ICON} style={{ width: 33, marginRight: 18 }} alt="salesforce icon" />
									: <img src={OUTREACH_ICON} style={{ width: 33, marginRight: 18 }} alt="outreach icon" />
								}
								<Typography
									style={{ minWidth: 130 }}
									text={`Created ${date}`}
									size="normal"
									color="textGrey"
									type="bold"
								/>
							</Styled.Descr>
						</Styled.Header>
						{Component && (
							<Component
								data={adapter()}
								defaultFields={defaultFields}
								isPadding={true}
								isDetail={true}
								{...rest}
							/>
						)}
					</Styled.Box>
					<Styled.Box order={2}>
						<Comments
							comments={comments}
							comment={comment}
							user={user}
							type={type}
							sendMessage={sendMessage}
							handleChange={handleChange}
						/>
					</Styled.Box>
				</Styled.Content>
			</Styled.Wrapper>
			<Modal isOpen={modalIsOpen} className="Shared">
				<Styled.ModalContent>
					<Styled.CloseBtnWrapper>
						<Styled.RoundBtn onClick={toggleModal}>
							<CloseIcon style={{ color: colors.black }} />
						</Styled.RoundBtn>
					</Styled.CloseBtnWrapper>
					<Styled.ModalTitle style={{ textAlign: 'center' }}>
						Sign up to leave a comment
					</Styled.ModalTitle>
					<Styled.BtnContainer>
						<AppButton
							title="Sign up with"
							color="blue"
							imageLeft={false}
							callBack={salesforceLogin}
							isLoading={isSalesLoading}
							image={
								<img
									src={salesforce}
									style={{ height: 30, marginTop: 2 }}
									alt=""
								/>
							}
						/>
						<Styled.Separator>
							<Styled.Line />
							<Styled.SeparatorText
								type="title"
								size={'normal'}
								color={'btnTextGrey'}
								text="OR"
							/>
							<Styled.Line />
						</Styled.Separator>
						<GoogleLogin
							clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID as string}
							onSuccess={handleLogin}
							cookiePolicy={'single_host_origin'}
							render={renderProps => (
								<AppButton
									title="Sign up with Google"
									color="white"
									titleColor="black"
									borderWidth={1}
									isBorder
									loaderColor="blue"
									isLoading={isGoogleLoading}
									callBack={renderProps.onClick}
									image={
										<img
											src={google}
											style={{ height: 22, marginRight: 10 }}
											alt=""
										/>
									}
								/>
							)}
						/>
					</Styled.BtnContainer>
				</Styled.ModalContent>
			</Modal>
		</div>
	);
};

export default SnapSharedPage;
